export const REQUIRED_FIELD = "Ovo polje je obavezno!";
export const AUTH_FAIL = "Nije moguće prijaviti se. Provjerite korisničko ime ili lozinku."
export const TWOFA_FAIL = "Netačаn kod,molimo pokušajte opet!";
export const USERNAME_EXIST  = "Korisnik sa ovim imenom već postoji!"
export const CHANGING_USERNAME  = "Nije moguće promijeniti ime korisnika!"
export const LENGTH_ERROR = "Dužina lozinke mora sadržati više od 8 karaktera!"
export const MATCH_PASSWORD = "Lozinke se moraju poklapati!"
export const TWOFA_ENABLED = "2FA uspješno omogućen."
export const TWOFA_DISABLED = "2FA uspješno ugašen."
